<template>
  <div
    class="has-show-count-down"
    v-show="isShowCountDown"
  >
    <div
      class="time-number"
      ref="countToAnswer"
      v-show="isShowTimeNumber"
    />
    <div
      class="time-up animate__bounceIn animate__animated"
      v-if="canShowTimesUp"
    >
      {{ $t("timesUp") }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'

export default {
  data() {
    return {
      countTimeToAnswer: -3,
      showTimeUp: false,
      showCountDown: true,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    canShowTimesUp() {
      return this.isTimesUp && this.showTimeUp
    },
    isTimesUp() {
      return !this.countTimeToAnswer || (this.countTimeToAnswer < 0 && this.countTimeToAnswer > -3)
    },
    isShowCountDown() {
      return this.slideActive.hasTimeLimit && this.countTimeToAnswer <= 3 &&
        this.countTimeToAnswer > -3 && this.showCountDown
    },
    isShowTimeNumber() {
      return this.countTimeToAnswer && this.countTimeToAnswer > 0
    },
  },
  mounted() {
    if (!this.slideActive.stopSubmission && this.slideActive.hasTimeLimit) {
      this._startCountDownTimeToAnswer()
    }
    EventBus.$on('startCountDownTime', () => {
      this._startCountDownTimeToAnswer()
    })
    EventBus.$on('setShowCountDown', (value) => {
      this.showCountDown = value
    })
  },
  methods: {
    _startCountDownTimeToAnswer() {
      this.showTimeUp = true
      const self = this

      self.countTimeToAnswer = JSON.parse(
        JSON.stringify(this.slideActive.timeToAnswer),
      )

      let secondTime = 0
      const startTime = utils.getCurTimeStamp() + this.slideActive.timeToAnswer * 1000

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime != timeRun) {
          secondTime = timeRun

          self.countTimeToAnswer = parseInt((startTime - utils.getCurTimeStamp()) / 1000, 10)

          if (self.$refs.countToAnswer) {
            self.$refs.countToAnswer.innerHTML = ''
            self.$refs.countToAnswer.innerHTML =
              `<div class='animate__bounceIn animate__animated'>${
                self.countTimeToAnswer
              }</div>`
          }
        }
        if (self.countTimeToAnswer > -3) {
          self.requestFrame = window.requestAnimationFrame(step)
        } else {
          self.requestFrame = null
        }
      }
      self.requestFrame = window.requestAnimationFrame(step)
    },
  },
}
</script>

<style lang="scss" scoped>
.has-show-count-down {
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 80px;
  font-weight: bold;
  position: absolute;
  align-items: center;
  justify-content: center;
  .time-number {
    font-size: 200px;
    font-weight: bold;
  }
}
</style>
